import template from './flexButton.template.html';

export default {
  template,
  bindings: {
    currentTicket: '<',
    isSidebarMinimized: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, ticketService, flexService, eventService, uiService) {
      'ngInject';

      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isCreatingFlexOpportunity = false;
      ctrl.errors = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentTicket = ctrl.currentTicket || {};
        ctrl.isSidebarMinimized = ctrl.isSidebarMinimized || false;
      };

      /*
       * Flex ~ Connect
       * --------------------------------------------------------------------------------
       */
      ctrl.flexConnect = () => {
        if (!ctrl.currentTicket.integrations.flexId) {
          ctrl.isCreatingFlexOpportunity = true;
          uiService.toast({
            text: {
              p1: 'Creating Opportunity in Flex',
              p2: ctrl.currentTicket.getName(),
              p3: 'please wait...'
            },
            warn: true
          });
          flexService.flexConnect({ idTicket: ctrl.currentTicket.id }).then((result) => {
            ctrl.isCreatingFlexOpportunity = false;
            if (result.status) {
              ctrl.currentTicket.integrations.flexId = result.flexId;
              uiService.toast({
                text: {
                  p1: 'Successfully created Opportunity',
                  p2: ctrl.currentTicket.getName(),
                  p3: 'in Flex'
                },
                success: true
              });
            } else {
              uiService.toast({
                text: {
                  p1: 'Cannot create Opportunity',
                  p2: 'Error returned from Flex',
                  p3: result.errorMessage
                },
                warn: true
              });

              eventService.lodgementResponseErrors({
                errors: result.errors,
                errorMessage: result.errorMessage,
                provider: 'Flex'
              });

              ctrl.errors = result.errors;
            }
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Disconnecting',
              p2: ctrl.currentTicket.getName(),
              p3: 'from Flex.'
            },
            warn: true
          });
          ticketService
            .updateTicket({ id: ctrl.currentTicket.id, integrations: { flexId: '' } })
            .then(() => {
              uiService.toast({
                text: {
                  p1: 'Successfully disconnected',
                  p2: ctrl.currentTicket.getName(),
                  p3: 'from Flex.'
                },
                warn: true
              });
              ctrl.currentTicket.integrations.flexId = '';
            });
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
